import config from 'admin-panel/config/environment';

export function resolveScreenshotUrl(screenshotUrl?: string) {
  const url = screenshotUrl?.trim();

  if (!url) {
    return undefined;
  }

  if (/^(?:https?:|data:)/.test(url)) {
    return url;
  }

  const host = config.api.host.replace(/\/$/, '');
  const path = url.startsWith('/') ? url : `/${url}`;

  return `${host}${path}`;
}
